<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :title="title"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body
      class="charge-apply-dialog"
      :before-close="handleClose"
      width="860px"
    >
      <div>
        <h1>{{ workflowTitle }}</h1>
        <table class="details-table" cellpadding="0" cellspacing="0">
          <tr v-if="!isApply">
            <td class="header">{{ $t('CargoMsg.Cargo_ApprovalSerialNumber') }}</td>
            <td class="values">{{ processInfo.documentProcessNo }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_StartDate') }}</td>
            <td class="values">{{ processInfo.createDate }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_Applicant') }}</td>
            <td class="values">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', contractBpm.createdBy, 'chineseName') }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_InitiateBranchCompany') }}</td>
            <td class="values">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', !processInfo ? $store.getters.currentOfficeId : processInfo.officeId, 'chineseName') }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_Parter') }}</td>
            <td class="values">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'uuid', contractBpm.companyUuid, 'chineseName') }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_ContractNumber') }}</td>
            <td class="values">{{ contractBpm.contractNo }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_EffectiveDate') }}</td>
            <td class="values">{{ ColumnUtils.dateLabelFunc(contractBpm.beginDate) }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_InvalidDate') }}</td>
            <td class="values">{{ ColumnUtils.dateLabelFunc(contractBpm.endDate) }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_ContractAgreement') }}</td>
            <td class="values">{{ ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACTAGREEMENT_TYPE, contractBpm.contractAgreement) }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_SettlementType') }}</td>
            <td class="values">{{ settlementByBill(contractBpm.snapCreditDateLimited) }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_Limit') }}</td>
            <td class="values">{{ contractBpm.snapCredit + contractBpm.currency }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_AccountPeriod') }}</td>
            <td class="values">{{ contractBpm.snapCreditDateLimited }}{{ termUnitConvert(contractBpm.termUnit) }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_SettlementMethod') }}</td>
            <td class="values">{{ creditDateTypeLabel(contractBpm.creditDateType) }}</td>
          </tr>
        </table>
        <div v-if="!isApply" style="margin-top: 20px; margin-bottom: 20px; width: 100%; height: 30px">
          <el-button style="float: right" type="primary" @click="onViewContractRequest">{{ $t('CargoMsg.Cargo_ViewContractDetails') }}</el-button>
        </div>
        <div v-if="!isApply" style="border: 1px solid #E3E3E3;">
          <div style="margin: 5px">
            <el-tabs v-model="activeName">
              <el-tab-pane v-if="isApprove" :label="$t('CargoMsg.Cargo_ApprovalComments')" name="comments">
                <process-content :form="form" />
              </el-tab-pane>
              <el-tab-pane :label="$t('CargoMsg.Cargo_ApprovalCommentsRecord')" name="record">
                <div style="max-height: 130px; overflow: auto">
                  <div v-for="(record, index) in records" :key="index">
                    <el-card class="box-card">
                      <div v-if="record.actionType !== Action_Type_Submit.code" style="display: flex">
                        <span>{{ $t('CargoMsg.Cargo_Approver') }}： </span>
                        <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalComments') }}： </span>
                        <span>{{ WorkflowUtil.getActionName(record.actionType) }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                        <span>{{ record.remark }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalTime') }}： </span>
                        <span>{{ record.createTime }}</span>
                      </div>
                      <div v-else style="display: flex">
                        <span>{{ $t('CargoMsg.Cargo_Initiator') }}： </span>
                        <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                        <span>{{ record.remark }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_StartTime') }}： </span>
                        <span>{{ record.createTime }}</span>
                      </div>
                      <div v-show="record.files && record.files.length > 0" style="margin-top: 10px;cursor: pointer;">
                        <div v-for="(file, index) in record.files" :key="index" style="display: inline-block;" class="file-style">
                          <div style="margin-left: 10px; display: flex" @click="downloadFile(file.fileId)">
                            <i class="el-icon-paperclip" />
                            <span class="file-name">{{ file.fileName }}</span>
                            <span style="color: darkgray;">{{ WorkflowUtil.fileSizeLabel(file.fileSize) }}</span>
                          </div>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div v-if="isApply && hasBtn" style="margin-top: 10px; margin-bottom: 10px">
          <span style="margin-left: 10px">{{ $t('CargoMsg.Cargo_Remarks') }}:</span>
          <process-content :form="form" />
        </div>
      </div>
      <template slot="footer" style="height: 65px">
        <div style="display: flex">
          {{ $t('CargoMsg.Cargo_RefuseAndReturnNode') }}
        </div>
        <div style="float: right; display: flex">
          <el-button v-for="(btn, index) in btnList" :key="index" :title="btn.title" :type="btn.color" @click="onAction(btn)">{{ btn.actionName }}</el-button>
          <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 加签 人员配置 -->
    <choose-user-dialog-add
      v-if="chooseUserDialogAdd.visible"
      :title="$t('CargoMsg.Cargo_SelectSigner')"
      :visible.sync="chooseUserDialogAdd.visible"
      :value="chooseUserDialogAdd.userIds"
      @close="chooseUserDialogAdd.visible=false"
      @change="addSignature"
    />
    <!-- 转签 人员配置 -->
    <choose-user-dialog-transfer
      v-if="chooseUserDialogTransfer.visible"
      :title="$t('CargoMsg.Cargo_SelectTransferor')"
      :visible.sync="chooseUserDialogTransfer.visible"
      :value="chooseUserDialogTransfer.userIds"
      @close="chooseUserDialogTransfer.visible=false"
      @change="transferSignature"
    />

    <contract-edit-window v-if="contractEditWindow.visible" :visible.sync="contractEditWindow.visible" :type="contractEditWindow.type" :model="contractEditWindow.contract" @reload="contractEditWindow.visible=false" />
  </div>
</template>
<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getAddSignatureInfo, workflowAction, workflowCheck } from '@/api/workflow'
import { getLoading } from '@/utils/utilBaseElement'
import ProcessContent from '@/components/Cargo/Common/Wrokflow/processContent'
import { deleteFile, uploadStorage } from '@/api/storage'
import { cache, cacheName } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ApprovalCommentsAndBtns from '@/components/Cargo/Common/Wrokflow/approvalCommentsAndBtns'
import {
  Action_Type_Add_Signature,
  Action_Type_Appoint,
  Action_Type_Approve,
  Action_Type_Auto_Press_To_Do,
  Action_Type_Cancel_Signature,
  Action_Type_Reject, Action_Type_Return, Action_Type_Submit,
  Action_Type_Transfer_Signature, APPLICATION_DIMENSION_CONTRACT,
  CONTRACT_APPLICATION_FORM
} from '@/class/cargo/model/parameters/WorkflowConstants'
import ChooseUserDialogAdd
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import ChooseUserDialogTransfer
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import URL from '@/api/urlTranslator'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import contractEditWindow from '@/views/cargo/v0/Information/ContractManagement/components/contractEditWindow.vue'
import { deepClone } from '@/utils'
import { getWorkFlowContract } from '@/api/partner/contractBpm'
import { getObjectByCache } from '@/utils/basicDataCache'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'ContractApplyDialog',
  components: { contractEditWindow, ProcessContent, cargoAdvanceSelect, ApprovalCommentsAndBtns, ChooseUserDialogAdd, ChooseUserDialogTransfer },
  props: {
    title: { type: String, default: () => '' },
    processInfo: { type: Object, default: () => {} }, // 审核流程id
    contractBpm: { type: Object, default: () => {} },
    type: { type: String, default: () => '' }, // apply-申请，look-查看，approve-审批
    status: { type: Number, default: () => null }, //
    records: { type: Array, default: () => [] }, // 审核记录
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      loading: null,
      form: {
        fileList: [],
        remark: ''
      },
      btnList: [],
      ColumnUtils: ColumnUtils,
      WorkflowUtil: WorkflowUtil,
      TYPE_NAMES: TYPE_NAMES,
      activeName: 'comments',
      documentProcessId: '',
      storageURL: '',
      workflowName: '',
      contractEditWindow: { // 编辑窗口
        type: 'look',
        visible: false,
        contract: null
      },
      cbTypeList: [
        { label: this.$t('Partners.monthlySettlement'), value: -1 },
        { label: this.$t('Partners.space3'), value: -2 },
        { label: this.$t('Partners.space4'), value: 'n' },
        { label: this.$t('Partners.space5'), value: -3 },
        { label: this.$t('Partners.dailySettlement'), value: -4 }
      ],
      skipApprove: true, // 跳过审核，为了达到刚进来是不显示弹窗的效果，默认值为true；在check之后，若不跳过审核 或 未匹配到审批流，都将该值赋false，即不跳过审核，即显示审批弹窗
      chooseUserDialogAdd: {
        visible: false,
        userIds: []
      },
      chooseUserDialogTransfer: {
        visible: false,
        userId: null
      },
      btn: null,
      Action_Type_Submit: Action_Type_Submit
    }
  },
  computed: {
    ContractConstants() {
      return ContractConstants
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    hasBtn() {
      return this.btnList && this.btnList.length > 0
    },
    isApply() {
      return this.type === 'apply'
    },
    isApprove() {
      return this.type === 'approve' && this.hasBtn
    },
    workflowTitle() {
      return this.workflowName || (this.processInfo ? this.processInfo.workflowName : '')
    },
    readonly() { // 付款申请单是否可编辑
      return (this.processInfo && !!this.processInfo.isClosed) || this.btnList.length === 0 || this.btnList.filter(btn => btn.actionType === Action_Type_Approve.code).length === 0
    },
    innerVisible: {
      get() {
        // 当提交时，skipApprove=true跳过审核，不展示弹窗
        return this.visible && (this.type === 'look' || !this.skipApprove)
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
    if (this.type !== 'look' || (this.processInfo && this.processInfo.state === 0)) {
      await this.init()
    }
    this.activeName = !this.isApprove ? 'record' : 'comments'
  },
  methods: {
    async init() {
      if (!this.contractBpm || !this.contractBpm.uuid) {
        return
      }
      const params = {
        documentConfigId: CONTRACT_APPLICATION_FORM.code,
        docId: this.contractBpm.uuid,
        officeId: this.$store.getters.currentOfficeId,
        documentProcessId: this.processInfo ? this.processInfo.documentProcessId : null
      }
      await workflowCheck(params).then(res => {
        if (res.data && res.data.skipApprove) {
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.$emit('closeAndRefresh')
          return
        }
        this.skipApprove = false
        if (res.data && res.data.actions && res.data.actions.length > 0) {
          const btns = res.data.actions
          for (const btn of btns) {
            btn.color = btn.actionType > Action_Type_Approve.code && [Action_Type_Auto_Press_To_Do.code, Action_Type_Add_Signature.code,
              Action_Type_Transfer_Signature.code, Action_Type_Appoint.code, Action_Type_Cancel_Signature.code].indexOf(btn.actionType) === -1 ? 'danger' : 'primary'
            btn.title = btn.actionType === Action_Type_Reject.code ? this.$t('CargoMsg.Cargo_RefuseTitle') : btn.actionType === Action_Type_Return.code ? this.$t('CargoMsg.Cargo_ReturnTitle') : ''
          }
          this.documentProcessId = res.data.documentProcessId
          this.workflowName = res.data.workflowName
          this.btnList = btns
        }
      }).catch(reason => {
        // 未匹配到审批流且抛异常时，不跳过审核
        this.skipApprove = false
      })
    },
    termUnitConvert(value) {
      switch (value) {
        case 0:
          return this.$t('Partners.day')
        case 1:
          return this.$t('Partners.week')
        case 2:
          return this.$t('Partners.month')
      }
    },
    creditDateTypeLabel(creditDateType) {
      if (!creditDateType) {
        return ''
      }
      this.cbType = ''
      // 结算方式
      if (creditDateType === -1 || creditDateType === 0) {
        this.cbType = -1
      } else if (creditDateType === -2) {
        this.cbType = -2
      } else if (creditDateType === -3) {
        this.cbType = -3
      } else if (creditDateType === -4) {
        this.cbType = -4
      } else if (creditDateType > 0) {
        this.cbType = 'n'
      }
      const data = this.cbTypeList.find(p => p.value === this.cbType)
      return data.label
    },
    settlementByBill(snapCreditDateLimited) { // 结算方式
      return (parseInt(snapCreditDateLimited) > 0 || (this.cbType && this.cbType === 'n')) ? this.$t('Partners.settlementNotByBill') : this.$t('Partners.settlementByBill')
    },
    // 按钮动作
    onAction(btn) {
      this.btn = btn
      // 【加签动作】
      if (btn.actionType === Action_Type_Add_Signature.code) {
        getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
          if (res.data.userIds && res.data.userIds.length > 0) {
            this.chooseUserDialogAdd.userIds = res.data.userIds
          }
          this.chooseUserDialogAdd.visible = true
        })
        return
      }
      // 【转签动作】
      if (btn.actionType === Action_Type_Transfer_Signature.code) {
        this.chooseUserDialogTransfer.visible = true
        return
      }
      this.doAction(btn)
    },
    doAction(btn) {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [btn.actionName]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        this.loading = getLoading()
        await this.upload()
        const params = {
          documentConfigId: CONTRACT_APPLICATION_FORM.code,
          docId: this.contractBpm.uuid,
          docNo: this.contractBpm.contractNo,
          actionId: btn.id,
          remark: this.form.remark,
          fileList: this.form.fileList,
          actionType: btn.actionType,
          officeId: !this.processInfo ? this.$store.getters.currentOfficeId : this.processInfo.officeId,
          documentProcessId: this.documentProcessId,
          applicationDimension: APPLICATION_DIMENSION_CONTRACT.code,
          signatureUserId: this.chooseUserDialogAdd.userIds && this.chooseUserDialogAdd.userIds.length > 0 ? this.chooseUserDialogAdd.userIds.join(',') : this.chooseUserDialogTransfer.userId,
          nodeId: !this.processInfo ? null : this.processInfo.nodeId
        }
        workflowAction(params).then(res => {
          this.$message.success(btn.actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          this.$emit('closeAndRefresh')
        }).catch(reason => {
          // 操作失败 且存在附件的情况下，删除附件
          this.removeFile()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    addSignature(userIds) {
      getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
        // 不允许对自己‘取消加签’
        if (res.data.userIds && res.data.userIds.length > 0) {
          if (res.data.userIds.indexOf(this.$store.getters.userId) !== -1 && userIds.indexOf(this.$store.getters.userId) === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignature'))
            return
          }
        }
        // 不允许对自己‘加签’
        if ((!res.data.userIds || res.data.userIds.indexOf(this.$store.getters.userId) === -1) && userIds.indexOf(this.$store.getters.userId) !== -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureSelf'))
          return
        }
        // 不允许对‘已审批’或‘已委派’的人‘取消加签’
        if (res.data.fixUserIds && res.data.fixUserIds.length > 0) {
          for (const userId of res.data.fixUserIds) {
            if (userIds.indexOf(userId) === -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignatureNotSupport'))
              return
            }
          }
        }
        // 会签下，不允许对当前节点人加签
        if (res.data.disableAddSignatureUserIds && res.data.disableAddSignatureUserIds.length > 0) {
          for (const userId of userIds) {
            if (res.data.disableAddSignatureUserIds.indexOf(userId) !== -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureCurrentNode'))
              return
            }
          }
        }
        this.chooseUserDialogAdd.visible = true
        this.chooseUserDialogAdd.userIds = userIds
        this.doAction(this.btn)
      })
    },
    transferSignature(userIds) {
      if (!userIds || userIds.length === 0) {
        return
      }
      // 只允许选择一个人‘转签人’
      if (userIds.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      // 不允许选择自己作为‘转签人’
      if (userIds[0] === this.$store.getters.userId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TransferSignatureSelf'))
        return
      }
      this.chooseUserDialogTransfer.visible = true
      this.chooseUserDialogTransfer.userId = userIds[0]
      this.doAction(this.btn)
    },
    handleClose() {
      this.innerVisible = false
      this.$emit('close')
    },
    // 合同详情
    onViewContractRequest() {
      getWorkFlowContract({ uuid: this.contractBpm.uuid }).then(async res => {
        const contract = deepClone(res.data)
        const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'uuid', contract.companyUuid)
        const customer = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
        console.log('.zxvasv.b....222.................', customer)
        contract.partnerId = company.cmpIdx
        if (customer) {
          contract.customerType = customer.customerType
        }
        contract.modifiedBy = 0
        this.contractEditWindow.contract = contract
        this.contractEditWindow.type = 'look'
        this.contractEditWindow.visible = true
      })
    },
    // 上传附件
    async upload() {
      const rows = this.form.fileList.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p
            params.documentType = 'workflow'
            return uploadStorage(params).then(res => {
              p.fileId = res.data
            })
          })
        )
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          `上传成功:${uploadSuccessCount}个,上传失败:${uploadFailCount}个.`,
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      }
    },
    // 动作提交失败，则删除附件
    removeFile() {
      const rows = this.form.fileList.filter(p => p.fileId)
      if (rows.length === 0) {
        return
      }
      Promise.all(
        Array.from(rows, p => {
          return deleteFile(p.fileId).then(res => {
          })
        })
      )
    },
    downloadFile(fileId) {
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
  .charge-apply-dialog{
    width: 100%;
    .el-dialog__footer{
      height: 60px;
    }
    h1{
      text-align: center;
    }
    tr{
      td {
        border: 1px solid #DCDFE6;
        padding: 5px;
        height: 35px;
        text-align: center;
        &.header {
          width: 15%;
          background-color: rgba(238, 248, 255, 1);
        }
        &.values {
          width: 35%;
          min-width: 100px;
        }
      }
    }
    .el-upload-dragger{
      margin-top: 10px;
      height: 40px;
      width: 130px;
      .el-icon-upload{
        margin: 15px 10px 16px !important;
        display: inline-block;
        font-size: 24px;
        line-height: 50px;
      }
    }
    .drop-uploader-icon{
      height: 100%; display: flex; align-items: center; justify-content: center;
    }
    .file-style{
      margin-top: 2px;
      width: 210px;
      height: 15px;
      background: linear-gradient(135deg,#f7faff, #ffffff);
      border-radius: 2px;
    }
    .file-name{
      width: 60%;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-input.el-input--mini {
      width: 100%;
      height: 100%;
      .el-input__inner{
        width: 100%;
        height: 100%;
      }
    }
    .el-input.el-input--mini.el-input--suffix{
      width: 100%;
      height: 100%;
      .el-input__inner{
        width: 100%;
        height: 100%;
      }
    }
    .el-select.el-select--mini{
      width: 100%;
      height: 100%;
      .el-input.el-input--mini.el-input--suffix{
        width: 100%;
        height: 100%;
        .el-input__inner{
          width: 100%;
          height: 100%;
        }
      }
    }
    .cargo-advance-select-wrapper{
      width: 100%;
      height: 100%;
      .el-select.el-select--mini{
        width: 100%;
        height: 100%;
        .el-input__inner{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
